import { SingleSearchParam } from "./SingleSearchParam";

export class ContactsSearchParams {

  page: SingleSearchParam;
  /** The Go API's token for `page`; empty for the first page. */
  pageToken: SingleSearchParam;
  sortBy: SingleSearchParam;
  sortDir: SingleSearchParam;
  q: SingleSearchParam;

  serialized: string;
  
  constructor(params: any) {
    this.page = new SingleSearchParam(params.page || 1)
    this.pageToken = new SingleSearchParam(params.pageToken || '')
    this.sortBy = new SingleSearchParam(params.sortBy)
    this.sortDir = new SingleSearchParam(params.sortDir)
    this.q = new SingleSearchParam(params.q || '')
    this.serialized = this.serialize()
  }

  serialize(page?: string, pageToken?: string) {
    const searchParams = new URLSearchParams()
    searchParams.set('q', this.q.serialize());
    searchParams.set('page', page ? page : this.page.serialize());
    const token = page ? pageToken : this.pageToken.value
    if (token) searchParams.set('pageToken', token);
    searchParams.set('sortBy', this.sortBy.serialize());
    searchParams.set('sortDir', this.sortDir.serialize());
    return searchParams.toString()
  }

  raw() {
    return {
      page: this.page.value,
      pageToken: this.pageToken.value,
      sortBy: this.sortBy.value,
      sortDir: this.sortDir.value,
      q: this.q.value,
      serialized: this.serialized
    }
  }

  toBody() {
    return {
      page: this.page.value,
      sortBy: this.sortBy.value,
      sortDir: this.sortDir.value,
      q: this.q.value,
    }
  }
}